import React from 'react';
import Days from './time/Days';
import ViewFilters from './filter/ViewFiltersDesktop';
import PerformanceFilters from './filter/PerformanceFilters';
import TimetableFilters from './filter/TimetableFilters';
import { ZOOM_LEVELS } from '../../../constants/settings';

const TimetableActions = ({
    isListView,
    toggleListView,
    toggleTimeView,
    isLiveView,
    selectDay,
    selectedDay,
    days,
    stagesFilters,
    artistsFilters,
    liveFilters,
    nonLinearFilters,
    artistOptions,
    toggleFiltersOpen,
    toggleActivityOpen,
    zoomIn,
    zoomOut,
    filtersOpen,
    activityOpen,
    hasFilter,
    stageOptions,
    setFilter,
    openSearch,
    isSearchOpen,
    openViewOptions,
    showDot,
    isViewFilterOpen,
    zoom
}) => (
    <div
        className={`ckp-timetable-actions ${filtersOpen ? 'is-with-filters' : ''} ${
            isListView ? '' : 'ckp-timetable-actions-fixed'
        }`}
    >
        {!isListView && (
            <div className="ckp-timetable-actions-zoom">
                <div className="ckp-timetable-actions-option is-buttons is-selected">
                    <a
                        onClick={zoomOut}
                        className={`ckp-timetable-actions-option-button is-min ckp-ts-h2 ${
                            zoom === ZOOM_LEVELS[0] ? 'is-disabled' : ''
                        }`}
                    >
                        -
                    </a>
                    <a
                        onClick={zoomIn}
                        className={`ckp-timetable-actions-option-button is-plus ckp-ts-h2 ${
                            zoom === ZOOM_LEVELS[ZOOM_LEVELS.length - 1] ? 'is-disabled' : ''
                        }`}
                    >
                        +
                    </a>
                </div>
            </div>
        )}
        <div className="ckp-timetable-actions-top">
            <div className="ckp-timetable-actions-left">
                {days && days.length && !isListView ? (
                    <Days selectDay={selectDay} selected={selectedDay} days={days} />
                ) : null}
                <ViewFilters
                    toggleTimeView={toggleTimeView}
                    toggleListView={toggleListView}
                    isLiveView={isLiveView}
                    isListView={isListView}
                />
            </div>
            <div className="ckp-timetable-actions-right">
                <TimetableFilters
                    hasFilter={hasFilter}
                    isSearchOpen={isSearchOpen}
                    openSearch={openSearch}
                    filtersOpen={filtersOpen}
                    activityOpen={activityOpen}
                    openViewOptions={openViewOptions}
                    isViewFilterOpen={isViewFilterOpen}
                    toggleFiltersOpen={toggleFiltersOpen}
                    toggleActivityOpen={toggleActivityOpen}
                    showDot={showDot}
                />
            </div>
        </div>
        {filtersOpen && (
            <PerformanceFilters
                stagesFilters={stagesFilters}
                artistsFilters={artistsFilters}
                liveFilters={liveFilters}
                nonLinearFilters={nonLinearFilters}
                artistOptions={artistOptions}
                stageOptions={stageOptions}
                setFilter={setFilter}
            />
        )}
    </div>
);

export default TimetableActions;



// WEBPACK FOOTER //
// ./src/components/application/timetable/TimetableActions.js